import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "timeAgo",
    pure: false,
    standalone: false
})
export class TimeAgoPipe implements PipeTransform {
  transform(sentAt: number): string {
    const now = new Date().getTime() / 1000; // Current time in seconds
    const diff = now - sentAt;

    if (diff < 60) {
      return diff.toFixed(0) + "s";
    } else if (diff < 3600) {
      return (diff / 60).toFixed(0) + "m";
    } else if (diff < 86400) {
      return (diff / 3600).toFixed(0) + "h";
    } else if (diff < 604800) {
      return (diff / 86400).toFixed(0) + "d";
    } else if (diff < 2419200) {
      return (diff / 604800).toFixed(0) + "w";
    } else if (diff < 29030400) {
      return (diff / 2419200).toFixed(0) + "mo";
    } else {
      return (diff / 29030400).toFixed(0) + "y";
    }
  }
}
